// Helper functions
function replaceUrlParam(url, paramName, paramValue) {
  var pattern = new RegExp('('+paramName+'=).*?(&|$)'),
      newUrl = url.replace(pattern,'$1' + paramValue + '$2');
  if ( newUrl == url ) {
    newUrl = newUrl + (newUrl.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
  }
  return newUrl;
}

// Home
if (window.location.href === "https://www.kingdom3d.com.au/#!home/zhmyg") {
   window.location.href = 'https://www.kingdom3d.com.au';
}

// Contact-us
if (window.location.href === "https://www.kingdom3d.com.au/#!contact-us/c24ju") {
   window.location.href = 'https://www.kingdom3d.com.au/pages/contact-us';
}

// About
if (window.location.href === "https://www.kingdom3d.com.au/#!about/cjg9") {
   window.location.href = 'https://www.kingdom3d.com.au/pages/about-us';
}

// Gallery
if (window.location.href === "https://www.kingdom3d.com.au/#!gallery/ypvk0") {
   window.location.href = 'https://www.kingdom3d.com.au/pages/gallery';
}

// Printing Tips
if (window.location.href === "https://www.kingdom3d.com.au/#!eSUN-Printing-Tips/cmbz/3") {
   window.location.href = 'https://www.kingdom3d.com.au/blogs/news';
}

// ABS
if (window.location.href === "https://www.kingdom3d.com.au/#!abs-filament/dotbl") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/abs';
}

// Leave Feedback
if (window.location.href === "https://www.kingdom3d.com.au/#!leave-feedback/lm756") {
   window.location.href = 'https://www.kingdom3d.com.au/pages/contact-us';
}

// By Length
if (window.location.href === "https://www.kingdom3d.com.au/#!filament-by-length/eeb8h") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/all-products/products/1-75mm-filament-by-length';
}

// Terms
if (window.location.href === "https://www.kingdom3d.com.au/#!terms-and-conditions/c24vq") {
   window.location.href = 'https://www.kingdom3d.com.au';
}

// Transparent
if (window.location.href === "https://www.kingdom3d.com.au/#!transparent-glass/zyi0n") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/transparent';
}

// PLA
if (window.location.href === "https://www.kingdom3d.com.au/#!pla-filament/kbfeo") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/pla';
}

// Print Service
if (window.location.href === "https://www.kingdom3d.com.au/#!print-service/k9ald") {
   window.location.href = 'https://www.kingdom3d.com.au';
}

// Light Blue
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/ecb11c69-2c3c-7199-b1e9-475e8f562e96") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-pla-light-blue-1kg-spool';
}

// Lumi Blue ABS
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/f99a7d3e-094f-bc67-20d1-73a34b11071e") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-abs-luminous-blue-1kg-spool';
}

// abs natural
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/e358f810-356b-7a39-2930-f4407ed4ba4a") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-abs-natural-1kg-spool';
}

// PLA Yellow
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/f86012b4-85ad-c37b-c5a0-e0879a60d305") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-pla-yellow-1kg-spool';
}

// PLA g5
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/7f5fbdd8-c5da-d3e6-2742-24a8bafd90cb") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/all-products/products/1-75mm-pla-filament-by-length';
}

// abs blue
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/fefe37a9-66c5-15f6-cffa-bf76c1ebc9a6") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-abs-blue-1kg-spool';
}

// abs perm
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/56c3a016-e552-2146-af2b-0fa1ed5ffd1e") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/all-products/products/1-75mm-filament-by-length';
}

// glass light blue
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/efe8a77b-dada-d3bf-7247-bec3693a4767") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-pla-glass-light-blue-1kg-spool';
}

// pla brown
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/5e7c4aad-f586-4424-ae31-bdd15755aa5a") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-pla-brown-1kg-spool';
}

// peak green
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/9a6fe417-765e-cf24-fa08-d86ccb31f098") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-pla-peak-green-1kg-spool';
}

// abs black
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/23573182-db95-25a4-40e1-710919b735bb") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-abs-black-1kg-spool';
}

// pla green
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/2817cb77-795b-1f13-f0c4-fd92e88f0467") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-pla-green-1kg-spool';
}

// abs yellow
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/49429761-a5d5-a92b-a019-cf48ecfbaee0") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-abs-yellow-1kg-spool';
}

// pla red
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/cc91c46f-f9f9-b508-3e35-6a9454b50118") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-pla-red-1kg-spool';
}

// abs grey
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/91033d86-3b79-b4eb-0f56-4cbad824cc93") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-abs-grey-1kg-spool';
}

// abs purple
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/a1d22b66-b659-bc2e-a1ee-dc092e6a2a15") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-abs-purple-1kg-spool';
}

// pla grey
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/84dd9919-c34b-9658-df8a-f2a871aff5f4") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-pla-grey-1kg-spool';
}

// abs gold
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/3a82e702-def4-c465-3ebc-92d006a24e00") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-abs-gold-1kg-spool';
}

// pla skin
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/3990b4eb-9207-e05e-1efa-cb86a0190fee") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-pla-skin-1kg-spool';
}

// pla pine green
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/c135be17-2d09-042a-5270-0d45a8544fbe") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-pla-pine-green-1kg-spool';
}

// pla gold
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/31848d12-975b-11e9-91c2-b249b9776c2e") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-pla-peak-gold-1kg-spool';
}

// pla blue
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/55bb2978-b926-fdbc-a1b7-cc70a49de1b4") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-pla-blue-1kg-spool';
}

// pla orange
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/4d332351-680b-c071-b32d-8047b9cd0760") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-pla-orange-1kg-spool';
}

// pla magenta
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/af59f9a6-a7f6-bf90-23ac-ad644ecd7693") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-pla-magenta-1kg-spool';
}

// abs green
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/45738e98-e86b-4734-1049-08f5dbc13564") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-abs-green-1kg-spool';
}

// pla pink
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/cfea5fd7-3195-2664-e49c-ed979fc60c71") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-pla-pink-1kg-spool';
}

// pla natural
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/eeb7d596-0c20-3083-ada0-68187a14093b") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-pla-natural-1kg-spool';
}

// pla per 10
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/efc8cfa0-38b7-a1c1-5688-8af06aee2c7d") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/all-products/products/1-75mm-pla-filament-by-length';
}

// abs peak green
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/67d5e37d-0a46-ccaa-6fdf-44202487aec0") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-abs-peak-green-1kg-spool';
}

// Trans Orange
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/757c7ec4-308a-ba2c-1442-f394272a930f") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-pla-glass-orange-1kg-spool';
}

// abs orange
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/260623ef-d528-9112-7c60-d929a7d59744") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-abs-orange-1kg-spool';
}

// glass purple
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/686c9aa4-6732-2e07-cd66-327d1838c5f4") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-pla-glass-purple-1kg-spool';
}

// abs lumi green
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/6705cb20-2417-03c4-4026-f55ded9bbe1a") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-abs-luminous-green-1kg-spool';
}

// abs pink
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/e655796a-66ea-55f3-7cba-8b91c09e1e49") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-abs-pink-1kg-spool';
}

// pla lumi blue
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/b11b7e53-2a63-6b4b-a7e3-530eb234e131") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-pla-luminous-blue-1kg-spool';
}

// abs red
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/99e7911d-72cd-8a02-f871-cc85837f72d6") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-abs-red-1kg-spool';
}

// abs silver
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/e89e4e9f-8251-3a6f-998c-523ba19815ef") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-abs-silver-1kg-spool';
}

// abs white
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/0953eaab-9a0a-2cdb-527b-1f31e3bf1ea6") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-abs-white-1kg-spool';
}

// abs light blue
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/b26418ef-41c6-6df0-ef38-384ec754ad95") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-abs-light-blue-1kg-spool';
}

// pla per 10
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/c2639ced-7150-bb8c-fd54-05b0d752f2cc") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/all-products/products/1-75mm-pla-filament-by-length';
}

// trans watermelon
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/13798835-0a21-85a7-1a8b-8e7ffbdf5b05") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-pla-glass-watermelon-1kg-spool';
}

// glass lemon
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/2ad338ff-435a-9c5a-dd33-28eda0b17d50") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-pla-glass-lemon-yellow-1kg-spool';
}

// pla purple
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/0c55a8b9-18e2-ab87-a4da-a0dc73e2c35d") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-pla-purple-1kg-spool';
}

// pla white
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/71acfafa-52b1-331a-27ec-bd77fe1d5295") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-pla-white-1kg-spool';
}

// pla silver
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/db3d18d7-b2b3-c1bf-ab3b-eaa7acddf584") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-pla-peak-silver-1kg-spool';
}

// abs per 10
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/d3ed2273-79b8-a68a-6cc8-9bc1d0dbcaf3") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/all-products/products/1-75mm-filament-by-length';
}

// pla lumi gren
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/b2cb9b52-5a6c-8d23-4fea-79607d3c592c") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-pla-luminous-green-1kg-spool';
}

// pla black
if (window.location.href === "https://www.kingdom3d.com.au/#!product-page/l7gwx/869e3f8b-74c3-8f45-8dc5-f010ade0384b") {
   window.location.href = 'https://www.kingdom3d.com.au/collections/1-75mm-filament/products/esun-3d-printer-filament-1-75mm-pla-black-1kg-spool';
}


// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html: $('html'),
    $body: $('body'),

    // Navigation
    $navigation: $('#AccessibleNav'),

    // Collection Pages
    $changeView: $('.change-view'),

    // Product Page
    $productImageWrap: $('#ProductPhoto'),
    $productImage: $('#ProductPhotoImg'),
    $thumbImages: $('#ProductThumbs').find('a.product-single__thumbnail')
  }
};

timber.init = function () {
  FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.productImageSwitch();
  timber.autoResponsiveElements();
  timber.collectionViews();
  timber.productImageZoom();
};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';
  
  

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector,
      translations = options.translations;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText');

  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, timber.switchImage);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html(translations.add_to_cart);
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html(translations.sold_out);
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html(Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html(translations.unavailable);
    $quantityElements.hide();
  }
};

timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      timber.switchImage(newImage, null, timber.cache.$productImage);
    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);

  
};

timber.autoResponsiveElements = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $('table').wrap('<div class="table-wrapper"></div>');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

timber.productImageZoom = function () {
  
    return;
  

  if (!timber.cache.$productImageWrap.length || timber.cache.$html.hasClass('supports-touch')) {
    return;
  };

  // Destroy zoom (in case it was already set), then set it up again
  timber.cache.$productImageWrap.trigger('zoom.destroy');

  timber.cache.$productImageWrap.addClass('image-zoom').zoom({
    url: timber.cache.$productImage.attr('data-zoom')
  });
};

// Initialize Timber's JS on docready
$(timber.init)